export default function StatsSection() {
  const stats = [
    { value: "30+", label: "Лет на рынке", sub: "С 1994 года" },
    { value: "3", label: "Юридических лица", sub: "КНР · Россия · Гонконг" },
    { value: "100%", label: "Белая таможня", sub: "ГТД/НДС · EAC" },
    { value: "4", label: "Маршрута доставки", sub: "Авто · ЖД · Море · Мульти" },
    { value: "BMW·VAG·JLR", label: "Марки автомобилей", sub: "Полные матрицы ТО" },
    { value: "0W–5W", label: "Shell Oils HK", sub: "100% оригинал из Гонконга" },
  ];

  return (
    <section className="bg-[#0A0F1A] border-y border-[#C9A84C]/20 py-16">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center text-center">
              <div
                className="text-[#C9A84C] font-black mb-1"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: "clamp(24px, 3vw, 40px)", letterSpacing: "0.04em" }}
              >
                {stat.value}
              </div>
              <div className="text-white text-sm font-semibold mb-1">{stat.label}</div>
              <div className="text-gray-500 text-xs">{stat.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
